import previous_visas from './previous_visas';
import current_visa from './current_visa';
import previous_country from './previous_country';

export default {
    previous_visas: previous_visas,
    current_visa: current_visa,
    previous_country: previous_country,
};
